// Mirrors src/new_designs/wingstop-ecommerce 2.html :root

export const OV2 = {
  primary: '#0e7c62',
  primaryDark: '#065f4a',
  primaryBright: '#10a37f',
  primaryLight: '#e8f5f0',
  accent: '#f5a623',
  accentLight: '#fef3e0',
  text: '#1d1d1f',
  textSecondary: '#86868b',
  border: '#e8e8ed',
  bgLight: '#f5f5f7',
  badgeHot: '#ff6b35',
  badgeNew: '#ff7eb3',
  radiusSm: '12px',
  radiusLg: '20px',
  utilityBarHeight: 36,
  storeHeaderMinHeight: 80,
  /** Align shell chrome with menu grid — wider than `lg` for retail parity */
  contentMaxWidth: 1480,
};

export const shellStickyTopHeight = OV2.utilityBarHeight + OV2.storeHeaderMinHeight + 32;
